import { render, staticRenderFns } from "./EventViewPopup.vue?vue&type=template&id=2ea8002d&"
import script from "./EventViewPopup.vue?vue&type=script&lang=js&"
export * from "./EventViewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports